export default __webpack_public_path__ + "static/media/Burn.718a1c91.svg";